<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-crypto__order-verify">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.orderCode" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="请输入用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%;">
        <el-table-column prop="orderCode" label="订单号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="commodityName" label="商品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="rechargeAmount" label="充值金额" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="verificationStatus" label="核验状态" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.verificationStatus === 0 || scope.row.verificationStatus === null" type="warning">待核验</el-tag>
            <el-tag v-if="scope.row.verificationStatus === 1" type="success">已到账</el-tag>
            <el-tag v-if="scope.row.verificationStatus === 2" type="danger">金额不符</el-tag>
            <el-tag v-if="scope.row.verificationStatus === 3" type="info">未到账</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="foundTime" label="创建时间" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column :label="$t('handle')" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('crypto:order:verify')" type="text" size="small" @click="verifyHandle(scope.row.id)">核验</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 核验弹窗 -->
      <verify-dialog v-if="verifyDialogVisible" ref="verifyDialog" @refreshDataList="getDataList"></verify-dialog>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import VerifyDialog from './crypto-order-verify-dialog'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/crypto/order/pending-list',
        getDataListIsPage: true
      },
      dataForm: {
        orderCode: '',
        userId: ''
      },
      verifyDialogVisible: false
    }
  },
  components: {
    VerifyDialog
  },
  methods: {
    verifyHandle (id) {
      this.verifyDialogVisible = true
      this.$nextTick(() => {
        this.$refs.verifyDialog.dataForm.id = id
        this.$refs.verifyDialog.init()
      })
    }
  }
}
</script>
